import { forwardRef } from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  icon?: React.ReactNode;
  error?: boolean;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className = '', icon, error, ...props }, ref) => {
    const baseClasses = "block w-full px-4 py-3 rounded-lg border bg-white shadow-sm focus:ring-2 focus:ring-opacity-50";
    const borderClasses = error 
      ? "border-red-300 focus:border-red-500 focus:ring-red-500" 
      : "border-gray-300 focus:border-primary-500 focus:ring-primary-500";
    
    if (icon) {
      return (
        <div className="flex rounded-lg shadow-sm">
          <span className="inline-flex items-center px-4 rounded-l-lg border border-r-0 border-gray-300 bg-gray-50 text-gray-500">
            {icon}
          </span>
          <input
            ref={ref}
            className={`${baseClasses} rounded-none rounded-r-lg ${borderClasses} ${className}`}
            {...props}
          />
        </div>
      );
    }

    return (
      <input
        ref={ref}
        className={`${baseClasses} ${borderClasses} ${className}`}
        {...props}
      />
    );
  }
);

Input.displayName = 'Input';

export default Input;